import type { ApiTenant, UiTenant } from '../../schemas/tenants.schema';

import { mapStatusFromApi } from './status.mappers';

/**
 * Maps user from Api to match UI schema.
 */
export function mapTenantFromApi(apiTenant: ApiTenant): UiTenant {
  return {
    id: apiTenant?.id ?? '',
    billingIdentity: apiTenant?.billingIdentity ?? null,
    defaultLocale: apiTenant?.defaultLocale ?? null,
    opsEmail: apiTenant?.opsEmail ?? null,
    canHaveAdditionalOrganizations:
      apiTenant?.canHaveAdditionalOrganizations ?? false,
    canHaveIndividualTrainers: apiTenant?.canHaveIndividualTrainers ?? false,
    // Stored as sent: sparse, NULL = all on. Enumerated here or it is dropped
    // on every tenant read, the panel included.
    features: apiTenant?.features ?? null,
    description: apiTenant?.description ?? '',
    domain: apiTenant?.domain ?? '',
    iconUrls: apiTenant?.iconUrls ?? null,
    // Was silently dropped here, which is why the column existed end-to-end on
    // the backend but nothing could ever render it.
    coverPhoto: apiTenant?.coverPhoto ?? null,
    // The renderable halves. Kept apart from the two fields above because those
    // travel back on the write path, where a URL is not a valid asset name.
    coverPhotoUrl: apiTenant?.coverPhotoUrl ?? null,
    logoUrl: apiTenant?.logoUrl ?? null,
    keywords: apiTenant.keywords ?? '',
    logoName: apiTenant?.logoName ?? '',
    name: apiTenant?.name ?? '',
    shortName: apiTenant?.shortName ?? '',
    splashScreenText: apiTenant?.splashScreenText ?? '',
    splashScreens: apiTenant.splashScreens ?? [],
    platformContentLabel: apiTenant?.platformContentLabel ?? null,
    premiumContentLabel: apiTenant?.premiumContentLabel ?? null,
    status: mapStatusFromApi(apiTenant.status),
    theme: apiTenant?.theme ?? {},
  };
}

// No `mapCreateTenantToApi` here any more. Nothing imported it — `createTenant`
// builds its own body — and it still forwarded `theme`, which is now the one
// field the create form must NOT send: colours have a single writer, the
// rebrand-theme route. Left in place it was a ready-made way to reintroduce
// exactly that.
